module.exports = __webpack_public_path__ + "static/media/DuplicateSlab-Heavy.744ed81e.woff2";